module.exports = __webpack_public_path__ + "media/packs/images/markers/delivered-location-ebd78eb18db8fad90520645175abf08c.svg";